import { VerificationStatus } from 'src/common/models/verificationModels';

export enum VerificationStatusActionType {
  Downloading = 'Downloading',
  Analyzing = 'Analyzing',
  Done = 'Done',
  Error = 'Error',
  Expired = 'Expired',
  Insufficient = 'Insufficient',
}

export interface VerificationStatusAction {
  type: VerificationStatusActionType;
}

export interface VerificationStatusState {
  isDownloading?: boolean;
  isAnalyzing?: boolean;
  isInsufficient?: boolean;
  isError?: boolean;
  isExpired?: boolean;
  isSuccess?: boolean;
}

const defaultState: VerificationStatusState = {
  isDownloading: false,
  isAnalyzing: false,
  isInsufficient: false,
  isError: undefined,
  isExpired: undefined,
  isSuccess: undefined,
};

export const verificationStatusReducer = (
  state: VerificationStatusState,
  action: VerificationStatusAction
): VerificationStatusState => {
  const { type } = action;
  switch (type) {
    case VerificationStatusActionType.Downloading:
      return {
        ...defaultState,
        isDownloading: true,
      };
    case VerificationStatusActionType.Analyzing:
      return {
        ...defaultState,
        isAnalyzing: true,
      };
    case VerificationStatusActionType.Done:
      return {
        ...defaultState,
        isSuccess: true,
      };
    case VerificationStatusActionType.Insufficient:
      return {
        ...defaultState,
        isInsufficient: true,
      };
    case VerificationStatusActionType.Expired:
      return {
        ...defaultState,
        isExpired: true,
      };
    case VerificationStatusActionType.Error:
      return {
        ...defaultState,
        isError: true,
      };
    default:
      return state;
  }
};

export const verificationStatusActionMap = new Map<
  VerificationStatus,
  VerificationStatusAction
>([
  [
    VerificationStatus.Failed,
    {
      type: VerificationStatusActionType.Error,
    },
  ],
  [
    VerificationStatus.Expired,
    {
      type: VerificationStatusActionType.Expired,
    },
  ],
  [
    VerificationStatus.InsufficientData,
    {
      type: VerificationStatusActionType.Insufficient,
    },
  ],
  [
    VerificationStatus.TransactionsProcessing,
    {
      type: VerificationStatusActionType.Downloading,
    },
  ],
  [
    VerificationStatus.GatheringData,
    {
      type: VerificationStatusActionType.Downloading,
    },
  ],
  [
    VerificationStatus.AnalyzingData,
    {
      type: VerificationStatusActionType.Analyzing,
    },
  ],
  [
    VerificationStatus.Done,
    {
      type: VerificationStatusActionType.Done,
    },
  ],
]);
